import React from 'react';

const Payment = () => {
    return (
        <div>
            <h1 style={{
                 margin:'200px 0'
             }} className="text-center py-5 head-title">Payment System Comming Soon</h1>
        </div>
    );
};

export default Payment;